/**
 * Password Simple — Minimal Page JavaScript
 */
(function () {
  'use strict';

  var pwdInput = document.getElementById('pwd-input');

  // Auto-focus input on page load
  if (pwdInput) {
    pwdInput.focus();
    setTimeout(function () {
      if (pwdInput) {
        pwdInput.focus();
      }
    }, 100);
  }

  // Ensure default Horizon theme password elements are hidden
  document.body.classList.add('pwd-active');
})();
